export const CHECKOUT_NAVIGATION = {
  ICONS: {
    VERIFICATION: "icomoon-breadcrumb-phone",
    ADDRESS: "icomoon-home",
    SHIPMENT: "icomoon-breadcrumb-shipping-colored",
    PAYMENT: "icomoon-breadcrumb-payment-colored",
    CART: "icomoon-breadcrumb-cart",
    BANK_OTP: "icomoon-breadcrumb-otp-filled",
  },
  NORMAL_CHECKOUT: {
    STEP_COUNT: {
      VERIFICATION_SCREEN: 1,
      ADDRESS_SCREEN: 2,
      SHIPMENT_SCREEN: 3,
      PAYMENT_SCREEN: 4,
      CART_SCREEN: 5,
      IDLE_SCREEN: 6,
    },
  },
  PAYMENT_GATEWAY: {
    STEP_COUNT: {
      VERIFICATION_SCREEN: 1,
      PAYMENT_SCREEN: 2,
      CART_SCREEN: 3,
      IDLE_SCREEN: 4,
    },
  },
};
